<template>
  <div v-if="showDevelopment">
    <div v-if="selectedBuildingInfo === null">
      <div v-if="!customerList">
        <v-layout row justify-center>
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular indeterminate :size="70" :width="7" color="purple"></v-progress-circular>
            </v-layout>
          </v-container>
        </v-layout>
      </div>
    </div>
    <div v-if="selectedBuildingInfo">
      <div v-if="kiosk !== 10">
      <FourLayout>
        <template v-slot:one>
          <InsightHex :number="occupants" title="Occupants" subtext="Right Now"></InsightHex>
        </template>
        <template v-slot:two>
          <InsightHex :number="onlineSensors" title="Sensors" subtext="Online"></InsightHex>
        </template>
        <template v-slot:three>
          <InsightHex :number="spacesAvailable" title="Spaces Available"
                      :subtext="totalSpaces + ' spaces'"></InsightHex>
        </template>
        <template v-slot:four>
          <InsightHex :number="occupancyScore" title="Occupancy Score" subtext="Percentage"></InsightHex>
        </template>
      </FourLayout>
      </div>
      <div v-if="true">
        <Plan></Plan>
      </div>
      <div v-if="kiosk !== 10">
      <ManagedSpaceTable v-if="selectedBuildingManagedSpaces !== []"
                         :managedSpaces="selectedBuildingManagedSpaces"></ManagedSpaceTable>
      </div>
    </div>

    <div>
      <v-row v-if="debug">
        <v-col cols="12">
          <v-card>
            <v-card-title>Debug</v-card-title>
            <p>Selected building sensor readings: {{ selectedBuildingSensorReadings }}</p>
            <p>Managed spaces for building with Readings (managedSpaces): {{ selectedBuildingManagedSpaces }}</p>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <br>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InsightHex from '../components/InsightHex'
import ManagedSpaceTable from '../components/ManagedSpaceTable'
import Plan from './Plan'
import FourLayout from '../components/FourLayout'

export default {
  name: 'building',
  components: {
    InsightHex,
    ManagedSpaceTable,
    Plan,
    FourLayout
  },
  data: () => {
    return {
      debug: false
    }
  },
  computed: mapState({
    buildings: function (state) {
      return state.building.buildings
    },
    customerList: state => state.building.customerList,
    selectedBuildingInfo: function (state) {
      return state.building.selectedBuildingInfo
    },
    selectedBuilding: function (state) {
      return state.building.selectedBuildingInfo
    },
    selectedBuildingSensorReadings: function (state) {
      return state.building.selectedBuildingSensorReadings
    },
    selectedBuildingManagedSpaces: function (state) {
      return state.building.managedSpaces
    },
    plansForBuilding: function () {
      if (this.selectedBuildingInfo === null) {
        return null
      }
      return this.selectedBuildingInfo.planbuilding_set
        .filter(plan => plan.shown)
    },
    selectedPlan: function () {
      if (this.plansForBuilding === null) {
        return null
      }
      let filteredPlanList = this.plansForBuilding.filter(plan => plan.id === this.selectedPlanId)
      if (filteredPlanList.length > 0) {
        return filteredPlanList[0]
      }
      return null
    },
    onlineSensors: function (state) {
      // console.log(this.selectedBuildingSensorReadings)
      // if (!this.selectedBuildingSensorReadings) {
      //   return '-'
      // }
      // return this.selectedBuildingSensorReadings.length
      // console.log(this.selectedBuildingInfo)
      // console.log(this.selectedPlan)
      let now = new Date().getTime()
      let total = 0
      let readings = state.building.selectedBuildingSensorReadings
      if (readings) {
        readings.forEach(element => {
          // console.log(element)
          if (((now - element.detail.time_epoch_milli) < 300000)) {
            total += 1
          }
        })
      }
      return total
    },
    occupants: function (state) {
      if ((!this.selectedBuildingManagedSpaces) || (this.selectedBuildingManagedSpaces.length === 0)) {
        return '-'
      }
      if (this.onlineSensors <= 0) {
        return '-'
      }
      return this.selectedBuildingManagedSpaces
        .filter(space => space.sensor.occupancy !== undefined)
        .reduce((prev, current) => prev + parseInt(current.sensor.occupancy), 0)
    },
    kiosk: state => state.auth.kiosk,
    spacesAvailable: function (state) {
      if (!this.selectedBuildingManagedSpaces) {
        return '-'
      }
      if (this.onlineSensors <= 0) {
        return '-'
      }
      return this.selectedBuildingManagedSpaces.filter(space => space.sensor.occupancy === 0).length
    },
    totalSpaces: function (state) {
      if (!this.selectedBuildingManagedSpaces) {
        return '-'
      }
      return this.selectedBuildingManagedSpaces.length
    },
    showDevelopment: function (state) {
      return state.auth.isDevelopment
    },
    occupancyScore: function (state) {
      if (this.totalSpaces === '-') {
        return '-'
      }
      if (this.spacesAvailable === '-') {
        return '-'
      }
      if (this.totalSpaces <= 0) {
        return '-'
      }
      if (this.onlineSensors <= 0) {
        return '-'
      }
      return Math.round((this.totalSpaces - this.spacesAvailable) / this.totalSpaces * 100) + '%'
    }
  }),
  methods: {}
}
</script>
